module.exports = __webpack_public_path__ + "img/Group 1094four-1.616d7ee1.svg";